/* srcc/modules/discounts/components/CreateOwner/styles.js */

export default theme => ({
  textField: {
    width: theme.spacing.unit * 20,
    marginRight: theme.spacing.unit * 2,
  },
  buttonContainer: {
    position: 'absolute',
    bottom: theme.spacing.unit * 3,
    right: theme.spacing.unit * 3,
  },
  universityPaper: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 2,
  },
  universityForm: {
    overflow: 'auto',
    maxHeight: theme.spacing.unit * 48.5,
    padding: theme.spacing.unit * 3,
  },
  collapse: {
    paddingLeft: theme.spacing.unit * 3,
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
  },
  chooseUniversityButton: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
});



// WEBPACK FOOTER //
// ./src/modules/discounts/components/CreateOwner/styles.js